/**
 * @React
 */
import { FC, useState } from "react";
/**
 * @MUI
 */
import { Card, CardContent, Typography, Box, IconButton } from "@material-ui/core";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import { Divider } from "@mui/material";
/**
 * @Types
 */
import { IDifferenceFromAgreement, IMonitoringAgreementCgsModel } from "../../../../types";
/**
 * @Components
 */
import TableTDListList from "../../../CustomComponents/TablesCompoent/Detail/DetailTDList";
import MonitoringLogsDetails from "../MonitoringLogsDetailsCgs";
import MonitoringApprovalHistory from "../MonitoringApprovalHistoryCgs";
import DetailsLayout from "../../../CustomComponents/DetailPageLayout";
import CardComponent from "../../../CustomComponents/CardComponent";
import DetailTableTR from "../../../CustomComponents/TablesCompoent/Detail/DetailTableTR";
import FilesContainer from "../../../CustomComponents/FilesContainer";
import CustomTooltip from "../../../CustomComponents/CustomTooltip";
/**
 * @Utilities
 */
import { IMonitoringCgsFields } from "../../../../types/monitoringCgsFields";
import DetailePageStyles from "../../../../utilities/DetailePageStayles";
import { monitoringValueMappers } from "../../../../utilities/Fields/CgsMonitoringFields/monitoringDeps";
import { getMappedValue } from "../../../../utilities/mappers";
import { fieldsCgs, valueFormatCgs } from "../../../../utilities/Fields/CgsMonitoringFields/fields/changesFields";
import axiosInstance from "../../../../utilities/axios";
import CustomInputFields from "../../../CustomComponents/CustomInputFields";
import MonitoringDeadlineApproveForm from "../../../FormComponent/MonitoringDeadlineAproveForm";
import TableComponent from "../MonitoringFieldsTable";

interface MonitoringCgsDetailsProps {
  data: IMonitoringCgsFields & Partial<IMonitoringAgreementCgsModel>;
  loading: boolean;
  generatedValues?: any;
  title?: string;
  monitoringCgsDetailsFields?: any;
  callback?: (data: any) => void;
}

const MonitoringCgsDetails: FC<MonitoringCgsDetailsProps> = ({
  data,
  generatedValues,
  title,
  loading,
  monitoringCgsDetailsFields,
  callback,
}: MonitoringCgsDetailsProps) => {
  const [updateMonitoringDeadlineApprove, setUpdateMonitoringDeadlineApprove] = useState(false);
  const classes = DetailePageStyles();
  const propertyMappings = {
    project_activities: ["activity_code", "activity_description"],
    actual_municipality: [`region`, `municipality`],
    bank: ["name"],
    mountainous_settlement: ["settlement"],
  };
  const mappingPropertyToOtherProperty = {
    project_activities: "cgs_nace_activities",
    actual_municipality: "municipalities",
    bank: "banks",
    mountainous_settlement: "mountainous_settlements",
  };
  const visibilityConditions = {
    monitoring_new_deadline: data.is_fullfilled_used_amount,
    unfulfilled_used_amount_reason: data.is_fullfilled_used_amount,
    unfulfilled_used_amount_month_day: data.is_fullfilled_used_amount,
    monitoring_deadline_comment: data.monitoring_deadline_comment ? false : true,
    monitoring_approval_deadline_comment: data?.monitoring_approval_deadline_comment ? false : true,

    // unfulfilled_used_amount_month_day: data.is_fullfilled_used_amount,
    unfulfilled_used_amount_recommendation_reason: data.is_fullfilled_used_amount && !data?.unfulfilled_used_amount_recommendation_reason ? true : false,
    // unfulfilled_used_amount_recommendation_reason: data.is_deadline_approve,
  };
  const shouldHideField = (fieldName: keyof typeof visibilityConditions) => {
    return visibilityConditions[fieldName] === true;
  };

  const gfn = (fieldName: string) => {
    const field = mappingPropertyToOtherProperty[fieldName as keyof typeof mappingPropertyToOtherProperty];
    if (field) {
      const dataSource = generatedValues[field];
      const properties = propertyMappings[fieldName as keyof typeof propertyMappings];
      const dataValue = data[fieldName as keyof (IMonitoringCgsFields & Partial<IMonitoringAgreementCgsModel>)];
      if (dataSource && properties && dataValue) {
        if (fieldName === "bank") {
          const value = dataSource[dataValue as string][properties[0]] || `ბაზაში არ იძებნება (${dataValue})`;
          return value;
        }
        if (fieldName === "project_activities" && Array.isArray(dataValue)) {
          const values = dataValue?.map((activity: any) => {
            if (!dataSource[activity]) {
              return `ბაზაში აქტივობა არ იძებნება - ${activity}`;
            }
            return `${(dataSource[activity] && dataSource[activity][properties[0]]) || "ბაზაში აქტივობა არ იძებნება"} - ${
              dataSource[activity][properties[1]] || `${activity}`
            }`;
          });
          return values;
        }
        if (fieldName === "actual_municipality") {
          return [
            {
              label: "რეგიონი",
              value: dataSource[dataValue as keyof typeof dataSource][properties[0]] || "ბაზაში არ იძებნება რეგიონი/მუნიციპალიტეტი",
            },
            {
              label: "მუნიციპალიტეტი",
              value: dataSource[dataValue as keyof typeof dataSource][properties[1]] || "ბაზაში არ იძებნება ასეთი რეგიონი/მუნიციპალიტეტი",
            },
          ];
        }
        if (fieldName === "mountainous_settlement") {
          return dataSource[dataValue as keyof typeof dataSource][properties[0]] || ``;
        }
      }
    }
    return null;
  };
  return (
    <>
      <DetailsLayout
        title={title}
        leftContent={
          <>
            {monitoringCgsDetailsFields.map((group: any) => {
              return (
                <CardComponent title={group.groupLabel} cardVariant="outlined">
                  {group.fields.map((field: any) => {
                    if (shouldHideField(field.name)) {
                      return null;
                    }
                    if (field.name === "amount_of_used_amount_table") {
                      return (
                        <TableComponent
                          fields={field.sub_fields}
                          data={data}
                          getMappedValue={getMappedValue as any}
                          monitoringValueMappers={monitoringValueMappers}
                          headers={["TEst"]}
                        />
                      );
                    }
                    if (field.name === "actual_municipality") {
                      const actual_municipality = (gfn(field.name) as { label: string; value: string }[]) || [];
                      return (
                        <>
                          <table className={classes.table}>
                            <tbody>
                              {actual_municipality.map(({ label, value }: { label: string; value: string }) => (
                                <DetailTableTR label={label} loading={loading}>
                                  {value}
                                </DetailTableTR>
                              ))}
                            </tbody>
                          </table>
                        </>
                      );
                    }
                    if (field.name === "mountainous_settlement") {
                      const mountainous_settlement = gfn(field.name) as string;
                      return (
                        <>
                          <table className={classes.table}>
                            <tbody>
                              <DetailTableTR label={field.label} loading={loading}>
                                {mountainous_settlement}
                              </DetailTableTR>
                            </tbody>
                          </table>
                        </>
                      );
                    }
                    if (field.name === "project_activities") {
                      const activites = (gfn(field.name) as string[]) || [];
                      return (
                        <table className={classes.table}>
                          <tbody>
                            <DetailTableTR label={field.label} loading={loading}>
                              <TableTDListList items={activites} />
                            </DetailTableTR>
                          </tbody>
                        </table>
                      );
                    }
                    if (field.name === "bank") {
                      const bank = gfn(field.name) as string;
                      return (
                        <table className={classes.table}>
                          <tbody>
                            <DetailTableTR label={field.label} loading={loading}>
                              {bank}
                            </DetailTableTR>
                          </tbody>
                        </table>
                      );
                    }
                    if (field.name === "unfulfilled_used_amount_month_day") {
                      return (
                        <>
                          {!updateMonitoringDeadlineApprove && data && monitoringCgsDetailsFields && (
                            <table className={classes.table}>
                              <tbody>
                                <DetailTableTR label={field.label} loading={loading}>
                                  {["ROLE_AGENCY"].includes(localStorage.getItem("role") ?? "") &&
                                  // !data?.is_deadline_approve &&
                                  !data?.is_fullfilled_used_amount ? (
                                    <TableTDListList
                                      items={[
                                        <CustomTooltip title={"რედაქტირება"} placement="bottom-end" arrow>
                                          <IconButton aria-label="edit" size="small" onClick={() => setUpdateMonitoringDeadlineApprove(true)}>
                                            <EditOutlinedIcon
                                              sx={{
                                                fontSize: "1rem",
                                                color: "#56B9E9",
                                              }}
                                            />
                                          </IconButton>
                                        </CustomTooltip>,
                                        getMappedValue(field, data, monitoringValueMappers),
                                      ]}
                                    />
                                  ) : (
                                    <> {getMappedValue(field, data, monitoringValueMappers)} </>
                                  )}
                                </DetailTableTR>
                              </tbody>
                            </table>
                          )}
                        </>
                      );
                    }
                    if (field.name === "monitoring_new_deadline") {
                      return (
                        <table className={classes.table}>
                          <tbody>
                            <DetailTableTR label={field.label} loading={loading}>
                              <>{getMappedValue(field, data, monitoringValueMappers)}</>
                            </DetailTableTR>
                            {updateMonitoringDeadlineApprove && data && monitoringCgsDetailsFields ? (
                              <tr
                                style={{
                                  borderBottom: "1px solid rgb(0, 0, 0, 0.23)",
                                  padding: "12px",
                                }}
                              >
                                <td
                                  colSpan={3}
                                  style={{
                                    padding: "20px",
                                  }}
                                >
                                  {data && (
                                    <MonitoringDeadlineApproveForm
                                      data={{
                                        _id: data?._id || "",
                                        monitoring_new_deadline: data?.monitoring_new_deadline || null,
                                        monitoring_deadline_comment: data?.monitoring_deadline_comment || "",
                                        unfulfilled_used_amount_month_day: 0,
                                        is_deadline_approve: data?.is_deadline_approve || false,
                                        contract_signed_date: data?.contract_signed_date || null,
                                      }}
                                      load={false}
                                      url={""}
                                      onClose={() => setUpdateMonitoringDeadlineApprove(false)}
                                      callback={callback}
                                    />
                                  )}
                                </td>
                              </tr>
                            ) : null}
                          </tbody>
                        </table>
                      );
                    }
                    return (
                      <table className={classes.table}>
                        <tbody>
                          {
                            <DetailTableTR label={field.label} loading={loading}>
                              <>{getMappedValue(field, data, monitoringValueMappers)}</>
                            </DetailTableTR>
                          }
                        </tbody>
                      </table>
                    );
                  })}
                </CardComponent>
              );
            })}
          </>
        }
      />
      {data && data?.attached_documents && data?.attached_documents?.monitoring_attachments.length > 0 && (
        <Card className={classes.component} variant="outlined">
          <CardContent>
            <Typography className={classes.cardSummary}>{"ფაილები/ფოტოები"}</Typography>
            <>
              <FilesContainer FilesList={data?.attached_documents.monitoring_attachments} mode={"view"} cols={6} />
            </>
          </CardContent>
        </Card>
      )}
      {data && data?.difference_from_agreement && (
        <Card className={classes.component} variant="outlined">
          <CardContent>
            <Typography className={classes.cardSummary}>{"განაცხადის ცვლილების ისტორია"}</Typography>
            <>
              <MonitoringLogsDetails
                changedDataHistory={data?.difference_from_agreement ?? ([] as IDifferenceFromAgreement[])}
                valueFormat={valueFormatCgs}
                fields={fieldsCgs}
              />
              <>
                <br />
                <br />
                <br />
                <Divider />
                <br />
                {data.monitoring_approval_history && data.monitoring_approval_history.length > 0 && (
                  <MonitoringApprovalHistory approvalHistory={data.monitoring_approval_history} generateValueFormat={valueFormatCgs} />
                )}
              </>
            </>
          </CardContent>
        </Card>
      )}
    </>
  );
};

export default MonitoringCgsDetails;

// if (group.groupName === 'fixed_assets_capital_expenditures_funds_turnover') {
//     console.log('group', group);
//     // const activites = gfn(group.fields[28].name) as string[] || [];
//     // const chunkArray = (arr, size) =>
//     //     Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
//     //         arr.slice(i * size, i * size + size)
//     //     );
//     // if (group.name === "amount_of_used_amount_table") {
//     //     return (
//     //         <thead>
//     //             <tr>
//     //                 <th style={{ fontSize: "12px", textAlign: "left", padding: "8px", width: "33.33%" }}>პროექტის ფარგლებში განხორციელებული ხარჯვა;</th>
//     //                 <th style={{ fontSize: "12px", textAlign: "left", padding: "8px", width: "33.33%" }}>მიზნობრივი ხარჯვა;</th>
//     //                 <th style={{ fontSize: "12px", textAlign: "left", padding: "8px", width: "33.33%" }}>არამიზნობრივი ხარჯვა;</th>
//     //             </tr>
//     //         </thead>
//     //     )
//     // }
//     return (
//         <CardComponent
//             title={group.groupLabel}
//             cardVariant="outlined"
//         >

//             {/* {group.name === "amount_of_used_amount_table" ?
//                 <TableComponent
//                     fields={group}
//                     data={data}
//                     getMappedValue={getMappedValue as any}
//                     monitoringValueMappers={monitoringValueMappers}
//                     headers={['TEst']}
//                 /> : <p>Test</p>} */}
//             {/* <table
//                 style={{
//                     width: "100%",
//                     borderCollapse: "collapse",
//                 }}
//             >

//                 <thead>
//                     <tr>
//                         <th style={{ fontSize: "12px", textAlign: "left", padding: "8px", width: "33.33%" }}>პროექტის ფარგლებში განხორციელებული ხარჯვა;</th>
//                         <th style={{ fontSize: "12px", textAlign: "left", padding: "8px", width: "33.33%" }}>მიზნობრივი ხარჯვა;</th>
//                         <th style={{ fontSize: "12px", textAlign: "left", padding: "8px", width: "33.33%" }}>არამიზნობრივი ხარჯვა;<i style={{
//                             fontSize: "10px",
//                             fontWeight: 100,
//                             color: "rgb(0, 0, 0, 0.8)",
//                         }}>(მოიცავს შემდეგს: არ არის შეძენილი გუდვილი; არ არის შეძენილი სატრანსპორტო საშუალებები და არ განხორციელებულა მათი რემონტი, გარდა სპეციალური საშუალებებისა, რომლებიც უშუალოდ გამოიყენება საწარმოს ტერიტორიაზე პროდუქციის/მომსახურების წარმოების პროცესში; სახელმწიფო ან/და კერძო საკუთრებაში არსებული უძრავი ქონების შეძენა ან/და საქართველოს სამოქალაქო კოდექსით გათვალისწინებული ფორმებით დროებით სარგებლობაში აღება; კერძო სამართლის იურიდიული პირის აქციების ან წილების შეძენა ან მართვაში აღება; საქართველოს კანონმდებლობის შესაბამისად გათვალისწინებული სახდელების (ჯარიმა, საურავი, პირგასამტეხლო და სხვა) გადახდა/დაფარვა)</i> </th>
//                     </tr>
//                 </thead>
//                 <tbody>
//                     <tr key={'10000001'}
//                         style={{
//                             borderBottom: "1px solid rgb(0, 0, 0, 0.23)",
//                             borderTop: "1px solid rgb(0, 0, 0, 0.23)",
//                         }}
//                     >
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px",
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px", // Ensures enough height
//                                 }}
//                             >
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[0].label}
//                                 </label>

//                                 {getMappedValue(group.fields[0], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px", // Ensures enough height
//                                 }}
//                             >
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>{group.fields[1].label}</label>
//                                 {getMappedValue(group.fields[1], data, monitoringValueMappers)}

//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[2].label}
//                                 </label>
//                                 {getMappedValue(group.fields[2], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                     </tr> */}
//             {/* <tr key={'10000002'}
//                         style={{
//                             borderBottom: "1px solid rgb(0, 0, 0, 0.23)",
//                         }}
//                     >
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}
//                             >
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[3].label}
//                                 </label>

//                                 {getMappedValue(group.fields[3], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px", // Ensures enough height
//                                 }}
//                             >
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>{group.fields[4].label}</label>
//                                 {getMappedValue(group.fields[4], data, monitoringValueMappers)}

//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[5].label}
//                                 </label>
//                                 {getMappedValue(group.fields[6], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                     </tr>
//                     <tr key={'10000003'}
//                         style={{
//                             borderBottom: "1px solid rgb(0, 0, 0, 0.23)",
//                         }}
//                     >
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px", // Ensures enough height
//                                 }}
//                             >
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>{group.fields[6].label}</label>

//                                 {getMappedValue(group.fields[6], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px", // Ensures enough height
//                                 }}
//                             >
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>{group.fields[7].label}</label>
//                                 {getMappedValue(group.fields[7], data, monitoringValueMappers)}

//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[8].label}
//                                 </label>
//                                 {getMappedValue(group.fields[8], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                     </tr>
//                     <tr key={'10000004'}
//                         style={{
//                             borderBottom: "1px solid rgb(0, 0, 0, 0.23)",
//                         }}
//                     >
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px", // Ensures enough height
//                                 }}
//                             >
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>{group.fields[9].label}</label>

//                                 {getMappedValue(group.fields[9], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px", // Ensures enough height
//                                 }}
//                             >
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>{group.fields[10].label}</label>
//                                 {getMappedValue(group.fields[10], data, monitoringValueMappers)}

//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label
//                                     style={{
//                                         fontSize: "11px",
//                                         color: "rgb(0, 0, 0, 0.8)",
//                                     }}>
//                                     {group.fields[11].label}
//                                 </label>
//                                 {getMappedValue(group.fields[11], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                     </tr>
//                     <tr key={'10000006'}
//                         style={{
//                             borderBottom: "1px solid rgb(0, 0, 0, 0.23)",
//                         }}
//                     >
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[12].label}
//                                 </label>
//                                 {getMappedValue(group.fields[12], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[13].label}
//                                 </label>
//                                 {getMappedValue(group.fields[13], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[14].label}
//                                 </label>
//                                 {getMappedValue(group.fields[14], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                     </tr>
//                     <tr key={'10000005'}
//                         style={{
//                             borderBottom: "1px solid rgb(0, 0, 0, 0.23)",
//                         }}
//                     >
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px", // Ensures enough height
//                                 }}
//                             >
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>{group.fields[15].label}</label>

//                                 {getMappedValue(group.fields[15], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px", // Ensures enough height
//                                 }}
//                             >
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>{group.fields[16].label}</label>
//                                 {getMappedValue(group.fields[16], data, monitoringValueMappers)}

//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[17].label}
//                                 </label>
//                                 {getMappedValue(group.fields[17], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                     </tr>
//                     <tr key={'10000007'}
//                         style={{
//                             borderBottom: "1px solid rgb(0, 0, 0, 0.23)",
//                         }}
//                     >
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[18].label}
//                                 </label>
//                                 {getMappedValue(group.fields[18], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[19].label}
//                                 </label>
//                                 {getMappedValue(group.fields[19], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                         <td style={{
//                             padding: "8px",
//                             fontSize: "12px"
//                         }}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     flexDirection: "column",
//                                     justifyContent: "space-between",
//                                     minHeight: "50px",
//                                 }}>
//                                 <label style={{
//                                     fontSize: "11px",
//                                     color: "rgb(0, 0, 0, 0.8)",
//                                 }}>
//                                     {group.fields[20].label}
//                                 </label>
//                                 {getMappedValue(group.fields[20], data, monitoringValueMappers)}
//                             </Box>
//                         </td>
//                     </tr> */}
//             {/* </tbody> */}
//             {/* </table > */}

//         </CardComponent>
//     )
// }
